class SnowplowEvent {
  constructor(schema, actionMap) {
    this.schema = schema
    this.actionMap = actionMap
  }

  getSchema() {
    return this.schema
  }

  analytics(data, contexts) {
    return {
      event: {
        schema: this.schema,
        data
      },
      contexts
    }
  }

  build(event, action) {
    let builtEvent = Object.assign({}, event)

    if (action && this.actionMap) {
      const data = {}

      Object.keys(this.actionMap).forEach(key => {
        const dataKey = typeof this.actionMap[key] === 'function' ? this.actionMap[key](action) : this.actionMap[key]
        data[key] = action[dataKey]
      })

      builtEvent.data = Object.assign(data, event.data)
    }

    return builtEvent
  }
}

export {SnowplowEvent}

export default SnowplowEvent
